<template>
  <div>
    <b-navbar class="nav-top" type="dark">
      <b-navbar-brand tag="h1" class="mb-0">
        <b style="font-size: 26px;">KMP Partners</b>
      </b-navbar-brand>
    </b-navbar>
    <b-navbar toggleable="lg" class="nav-bottom">
      <b-navbar-toggle target="navbar" v-if="navbottomStatus"></b-navbar-toggle>
      <b-collapse id="navbar" is-nav v-if="navbottomStatus">
        <b-navbar-nav>
        </b-navbar-nav>
        <b-navbar-nav class="ml-auto">
        </b-navbar-nav>
      </b-collapse>
    </b-navbar>
  </div>
</template>
<script>
export default {
  data() {
    return {
      username: null,
      navbottomStatus: false
    };
  }
};
</script>
<style>
.nav-top {
  background-color: rgb(27, 27, 27);
  height: 70px;
  font-family: "Taviraj" !important;
}
.nav-bottom {
  font-family: "Taviraj" !important;
  background-color: #d91e18;
}
</style>
